import React, { Fragment } from "react";
import { Button, Form } from 'react-bootstrap';
import {addInstance} from '../../services/dataService';
import bootoast from '../../bootoast/bootoast';


export default class AddFormModal extends React.Component {

    constructor(props){
        super(props);
        this.state = {showMenu:false, showAddError:false, selectedForm:null};
        
    }


    componentDidUpdate(prevProps) {
        if (prevProps.availableForms !== this.props.availableForms && this.props.availableForms!= null &&  this.props.availableForms.length > 0) {
            this.setState({selectedForm:this.props.availableForms[0].value})
        }

      }


    render() {
        
        return (
                <Fragment>
                { !this.state.showMenu && this.props.availableForms && this.props.availableForms.length > 0 &&
                <Fragment>
            
                    <Button onClick={()=>this.setState({showMenu:true})} >Fill out a new form</Button>
                       
                    <Fragment>
                        <Form.Group className="new-form-controls">
                            <Form.Label>Select a form to add</Form.Label>
                                <Form.Control as="select"
                                value={this.state.selectedForm || ""}
                                
                                onChange={(e,f)=>this.setState({selectedForm:e.target.value})}>
                                {this.renderOptions()}
                            </Form.Control>
                        </Form.Group>

                        <div className="form-group">
                            <Button style={{marginRight:"10px"}} onClick={()=>this.addForm()} disabled={!this.props.availableForms} >Add Form</Button>
                            <Button onClick={()=>this.setState({showMenu:false})}>Cancel</Button>
                        </div>
                        
                        {this.state.showAddError &&
                        
                        <div className="form-group">
                            <Button onClick={()=>this.setState({showAddError:false})}>Error</Button>
                        </div>

                        }
                    </Fragment>
                </Fragment>
                }
                </Fragment>

        );
    }

    renderOptions = ()=>{
        if(this.props.availableForms){
            return this.props.availableForms.map((item) => {
                return (<option key={item.value} value={item.value}>{item.label}</option>)                        
            })    
        }
    }

    addForm = async() => {

        if(this.state.selectedForm){

            try
            {

                await addInstance( this.props.selectedRecipientId, this.state.selectedForm )
                this.props.handleRefresh();        
                this.setState({showMenu:false});    
            }
            catch(err){
                console.log("could not add form");
                bootoast.toast({
                    position: 'top',
                    message: `Error saving form, it is possible that someone else added it already hit refresh`,
                    type: 'danger',
                    timeout: 7
                  });
            }
        }



    }

}




